import { useTrackViewed, useSegment } from "tracking"

export const useQuizInsertTracking = () => {
  const { track } = useSegment()
  const { ref } = useTrackViewed(
    [
      {
        event: "Page Element Viewed",
        properties: {
          location_type: "Search Quiz Insert",
          module_content: "Quiz Insert",
        },
      },
    ],

    {
      threshold: 0.3,
      triggerOnce: true,
    }
  )
  const trackQuizClick = () => {
    track({
      event: "Page Element Clicked",
      properties: {
        location_type: "Search Quiz Insert",
        module_content: "Quiz Insert",
        module_content_details: "Take the Skincare Quiz",
        location_type_details: "search_menu", // This was added as part of MPL-571 `Order It Again` on Search component
      },
    })
  }
  return {
    trackingRef: ref,
    trackQuizClick,
  }
}
